// 列表组件需要的数据
export const OPTHINES = {
  voteName: '2020project/2020green',
  mustSearch: 'Button',
  number: {
    mustRank: true,
  },
  listData: {
    type: 'com',
  },
  themeColor: {
    activeBgColor: '#278b09',
    inactiveBgColor: '#fff',
  },
  buttonBg: {
    backgroundColor: '',
  },
  tabs: [
    {
      tabName: '视频展示',
      tabPath: '/20200806GREEN/List',
    },
    {
      tabName: '相关新闻',
      tabPath: '/20200806GREEN/News',
    },
    {
      tabName: '活动规则',
      tabPath: '/20200806GREEN/Rules',
    },
  ],
};
